var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHalalSertified2 = function SvgHalalSertified2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 43,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#HalalSertified2_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#HalalSertified2_svg__b)",
    d: "M38.847 22.86c-.4 1.325-1.07 1.787-2.212 2.017-1.507.297-2.925 1.031-4.415 1.447-1.443.403-2.916.794-4.397.909-1.766.135-2.564-.684-2.84-2.454-.319-2.046-.637-4.092-1.087-6.147-.972 3.21-1.125 6.78-4.309 8.847-1.935 1.256-4.113 1.664-6.443 1.524.526-.208 1.04-.467 1.583-.62 4.907-1.384 6.987-5.14 8.031-9.687.438-1.902.595-3.867 1.121-5.833.37 2.063.709 4.14 1.125 6.194.318 1.566.658 3.137 1.142 4.656.607 1.915 1.863 2.67 3.812 2.174 1.74-.442 3.409-1.159 5.11-1.753l.014-.484c-1.257-.454-2.5-1.235-3.77-1.278-1.231-.042-2.488.67-3.689 1.044 1.091-2.61 2.687-3.298 5.09-1.96 1.889 1.048 3.846 1.633 6.134 1.404"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#HalalSertified2_svg__c)",
    d: "M5.769 23.972c0 .178.008.36 0 .54-.119 2.729.7 3.824 4.05 3.124 2.254-.472 4.062-1.503 3.68-4.666-.357-2.941-.67-5.892-.98-8.838-.056-.543-.01-1.095-.01-2.025 1.003 1.108 1.53 1.783 1.478 3.053-.085 2.173.238 4.372.471 6.55.497 4.58-2.305 7.725-6.949 7.734-2.194 0-3.217-1.21-2.759-3.345.161-.739.467-1.448.709-2.17q.155.022.31.043"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#HalalSertified2_svg__d)",
    d: "M20.762 22.664c-1.06-2.165-2.436-3.591-4.266-4.678-.632-.378-.853-1.452-1.384-2.441 2.95.56 5.234 3.515 5.65 7.119"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#HalalSertified2_svg__e)",
    d: "M21.234 2.6c10.426 0 18.912 8.48 18.912 18.91s-8.482 18.912-18.912 18.912S2.323 31.936 2.323 21.511 10.809 2.599 21.234 2.599m0-2.102C9.628.498.222 9.905.222 21.511c0 11.605 9.406 21.012 21.012 21.012s21.013-9.407 21.013-21.012S32.84.498 21.234.498"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "HalalSertified2_svg__b",
    x1: 19.569,
    x2: 27.896,
    y1: 12.863,
    y2: 32.722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "HalalSertified2_svg__c",
    x1: 7.111,
    x2: 19.478,
    y1: 12.107,
    y2: 22.671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "HalalSertified2_svg__d",
    x1: 16.525,
    x2: 21.589,
    y1: 15.545,
    y2: 21.574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "HalalSertified2_svg__e",
    x1: 10.728,
    x2: 38.745,
    y1: 0.498,
    y2: 42.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "HalalSertified2_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.17.498h42v42h-42z"
  })))));
};
export default SvgHalalSertified2;